// noinspection DuplicatedCode
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import "react-datepicker/dist/react-datepicker.css";


import {getKaryawanReport, karyawanSelector, resetKaryawanSlice,} from "./karyawanSlice";

import {Colors} from "../../../assets/Colors";
import Skeltons from "../../../components/loading/Skeltons";
import DynamicTable from "../../../components/tablecard/DynamicTable";
import {BarGraphOutside, PieGraphOutside} from "../../../components/graph/GraphBuilder";
import {Card} from "@material-tailwind/react";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import {useForm} from "../../../components/isRequired";
import {downloadExcel} from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// ── Label kode->teks, DUPLIKAT dari mapping bawaan DynamicTable.js supaya
// Export Excel/PDF menampilkan label yang sama seperti yang tampil di layar
// (export di sini tidak menggores DOM DynamicTable, jadi dipetakan ulang di
// sini — dengan perbandingan longgar String(v), beda dari DynamicTable yang
// sebagian membandingkan angka mentah dgn string "1" sehingga Agama/Warga
// Negara di tabel layar tampil kode mentah, bukan bug yang ditambahkan di sini).
const pendidikanLabel = (v) => ({
    "1": "SD", "2": "SMP", "3": "SMA", "4": "D1", "5": "D2",
    "6": "D3", "7": "S1", "8": "S2", "9": "S3",
}[String(v)] || "-");
const agamaLabel = (v) => ({
    "1": "Islam", "2": "Protestan", "3": "Katolik", "4": "Hindu", "5": "Budda", "6": "Konghucu",
}[String(v)] || "-");
const statusPerkawinanLabel = (v) => ({"1": "Belum Menikah", "2": "Menikah"}[String(v)] || "-");
const statusPajakLabel = (v) => ({
    "1": "TK0", "2": "TK1", "3": "TK2", "4": "TK3", "5": "K0", "6": "K1", "7": "K2", "8": "K3",
}[String(v)] || "-");
const wargaNegaraLabel = (v) => ({"1": "Indonesia", "2": "Asing"}[String(v)] || "-");
const jenisKelaminLabel = (v) => (String(v) === "1" ? "Pria" : "Wanita");
const sistemGajiLabel = (v) => (String(v) === "1" ? "Transfer" : String(v) === "2" ? "Cash" : "-");
const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("id-ID") : "-");

// ── Usia pensiun karyawan swasta (Program Jaminan Pensiun BPJS
// Ketenagakerjaan) per PP No. 45 Tahun 2015 Pasal 15: 56 th saat mulai
// berlaku (Jul 2015), naik jadi 57 th mulai 2019, lalu +1 th tiap 3 tahun
// berikutnya sampai maksimal 65 th (tercapai tahun 2043).
const usiaPensiunTahun = (tahun) => {
    if (tahun < 2019) return 56;
    return Math.min(65, 57 + Math.floor((tahun - 2019) / 3));
};
// Umur genap per hari ini (bukan cuma selisih tahun) supaya "sudah pensiun"
// akurat terhadap tanggal ulang tahun, bukan cuma tahun kelahiran.
const hitungUmur = (tglLahirISO) => {
    if (!tglLahirISO) return null;
    const lahir = new Date(tglLahirISO);
    if (isNaN(lahir)) return null;
    const now = new Date();
    let umur = now.getFullYear() - lahir.getFullYear();
    const belumUlangTahun =
        now.getMonth() < lahir.getMonth() ||
        (now.getMonth() === lahir.getMonth() && now.getDate() < lahir.getDate());
    if (belumUlangTahun) umur -= 1;
    return umur;
};
// Tanggal persis genap usia pensiun — dicari tahun PERTAMA di mana umur
// (tahun berjalan) sudah menyentuh ambang usia pensiun tahun ITU (ambang
// naik bertahap tiap 3 th, lihat usiaPensiunTahun di atas), bukan cuma
// dibandingkan ambang tahun ini — supaya konsisten walau karyawan sudah
// lama lewat usia pensiun dari ambang tahun-tahun sebelumnya.
const hitungTanggalPensiun = (tglLahirISO) => {
    if (!tglLahirISO) return null;
    const lahir = new Date(tglLahirISO);
    if (isNaN(lahir)) return null;
    const tahunLahir = lahir.getFullYear();
    for (let tahun = tahunLahir + 56; tahun <= tahunLahir + 65; tahun++) {
        if (tahun - tahunLahir >= usiaPensiunTahun(tahun)) {
            const tgl = new Date(lahir);
            tgl.setFullYear(tahun);
            return tgl;
        }
    }
    const tgl = new Date(lahir);
    tgl.setFullYear(tahunLahir + 65);
    return tgl;
};

const KaryawanReport = ({}) => {
    let initialState = {
        bulan: new Date(),
        // "ALL" = semua Bisnis Unit (backend menerjemahkan ke tanpa filter).
        bisnisUnitId: "ALL",
    };
    const validations = [];

    const {
        values,
        errors,
        touched,
        customHandler,
    } = useForm(initialState, validations);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const elementRef = useRef(null);
    const [data, setData] = useState(null);
    const [statisticJenjang, setStatisticJenjang] = useState(null);
    const [statisticGolongan, setStatisticGolongan] = useState(null);
    const [statisticAgama, setStatisticAgama] = useState(null);
    const [statisticJK, setStatisticJK] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [pageC, setPageC] = useState(1);
    // Loading skeleton — mengikuti pola halaman report lain: aktif sejak
    // dispatch sampai selesai (dijaga .finally() agar tak macet bila gagal).
    const [fetching, setFetching] = useState(true);
    const PAGE_SIZE = 10;

    const karyawan = useSelector(karyawanSelector);

    const dispatch = useDispatch();
    useEffect(() => {
        setFetching(true);
        dispatch(
            getKaryawanReport({
                "tahun": values.bulan.getFullYear().toString(),
                "bulan": "",
                "BisnisUnitID": values.bisnisUnitId
            })
        ).finally(() => setFetching(false));
    }, []);


    useEffect(() => {
        if (karyawan.isGetReport) {
            dispatch(resetKaryawanSlice({}))
            if (!karyawan.report.DataKaryawan) {
                setData([])
                setStatisticAgama([])
                setStatisticGolongan([])
                setStatisticJenjang([])
                setStatisticJK([])
            } else {
                setData(karyawan.report.DataKaryawan)
                setStatisticAgama(karyawan.report.Agama)
                setStatisticGolongan(karyawan.report.Golongan)
                setStatisticJenjang(karyawan.report.Jenjang)
                setStatisticJK(karyawan.report.JenisKelamin)
            }
        }
    });
    useEffect(() => {
        // Div berisi elementRef baru ter-render setelah fetching selesai
        // (sebelum itu yang tampil Skeltons) — cek null supaya tak crash
        // saat efek ini sempat jalan lebih dulu pada mount awal.
        if (!elementRef.current) return;
        setWidth(elementRef.current.getBoundingClientRect().width);
        setHeight(elementRef.current.getBoundingClientRect().height);
    }, [fetching]);
    const header = [
        {name: "Nik", key: "Nik"},
        {name: "Nama Karyawan", key: "NamaKaryawan", modifiers: "Text"},
        {name: "Tempat Lahir", key: "TempatLahir", modifiers: "Text"},
        {name: "Tanggal Lahir", key: "TanggalLahir", modifiers: "Date"},
        {name: "Umur", key: "Umur", modifiers: "Number"},
        {name: "Tanggal Pensiun", key: "TanggalPensiun", modifiers: "Text"},
        {name: "Status Pensiun", key: "StatusPensiun", modifiers: "Text"},
        {name: "Alamat", key: "Alamat", modifiers: "Text"},
        {name: "Kota", key: "NamaKota", modifiers: "Text"},
        {name: "Provinsi", key: "NamaProvinsi", modifiers: "Text"},
        {name: "Jenis Kelamin", key: "JenisKelamin", modifiers: "JenisKelamin"},
        {name: "Pendidikan", key: "LevelPendidikan", modifiers: "Pendidikan"},
        {name: "Status Perkawinan", key: "StatusPerkawinan", modifiers: "StatusPerkawinan"},
        {name: "Jml Anak", key: "JmlAnak", modifiers: "Number"},
        {name: "JmlTanggungan", key: "JmlTanggungan", modifiers: "Number"},
        {name: "Status Pajak", key: "StatusPajak", modifiers: "StatusPajak"},
        {name: "NPWP", key: "NPWP", modifiers: "Text"},
        {name: "Tgl Masuk Kerja", key: "TanggalMasuk", modifiers: "Date"},
        {name: "Tipe Karyawan", key: "NamaTipeKaryawan", modifiers: "Text"},
        {name: "Jabatan", key: "NamaJabatan", modifiers: "Text"},
        // Kunci dibetulkan dari "WargaNegara" -> "Warganegara" supaya cocok dgn
        // field JSON backend (casing berbeda persis di huruf N/n) — sebelumnya
        // kolom ini selalu kosong karena key-nya tak pernah match.
        {name: "Warga Negara", key: "Warganegara", modifiers: "WargaNegara"},
        {name: "Agama", key: "Agama", modifiers: "Agama"},
        {name: "Golongan Darah", key: "GolonganDarah", modifiers: "Text"},
        {name: "No Hp", key: "NoHp", modifiers: "Text"},
        {name: "No Tlpn", key: "NoTlpn", modifiers: "Text"},
        {name: "No Rekening Bank", key: "NoRekeningBank", modifiers: "Text"},
        {name: "Nama Bank", key: "NamaBank", modifiers: "Text"},
        {name: "Nama Pemilik Rekening", key: "PemilikBank", modifiers: "Text"},
        {name: "SistemGaji", key: "SistemGaji", modifiers: "SistemGaji"},
        {name: "NoKTP", key: "NoKTP", modifiers: "Text"},
        {name: "NoKK", key: "KartuKeluarga", modifiers: "Text"},
        {name: "BPJS", key: "BPJS", modifiers: "Text"},
        {name: "NamaBisnisUnit", key: "NamaBisnisUnit", modifiers: "Text"},
        {name: "Email", key: "Email", modifiers: "Text"},


    ]

    // ── Penanda pensiun — dihitung dari TanggalLahir, bukan dari backend,
    // supaya patokan usia pensiun selalu ikut tahun berjalan (lihat
    // usiaPensiunTahun di atas) tanpa perlu ubah API.
    const tahunIni = new Date().getFullYear();
    const usiaPensiunTahunIni = usiaPensiunTahun(tahunIni);

    // ── Search (client-side, di seluruh data hasil "Buka") + Pagination ──
    const baseRows = (Array.isArray(data) ? data : []).map((r) => {
        const umur = hitungUmur(r.TanggalLahir);
        const sudahPensiun = umur !== null && umur >= usiaPensiunTahunIni;
        const tglPensiun = hitungTanggalPensiun(r.TanggalLahir);
        // "Pensiun tahun ini" = tahun genap usia pensiun jatuh di tahun
        // berjalan — mencakup yg ultah-pensiunnya sudah lewat maupun yg
        // masih akan datang tahun ini, keduanya sama-sama "di tahun ini".
        const pensiunTahunIni = !!tglPensiun && tglPensiun.getFullYear() === tahunIni;
        let statusPensiun = "-";
        if (pensiunTahunIni) {
            statusPensiun = `🔴 Pensiun Tahun Ini (${fmtDate(tglPensiun)})`;
        } else if (sudahPensiun) {
            statusPensiun = `⚠ Sudah Pensiun (${umur} th)`;
        }
        return {
            ...r,
            TanggalPensiun: tglPensiun ? fmtDate(tglPensiun) : "-",
            StatusPensiun: statusPensiun,
            _umur: umur,
            _sudahPensiun: sudahPensiun,
            _pensiunTahunIni: pensiunTahunIni,
        };
    });

    // ── Statistik kategori usia kerja — dihitung dari data hasil "Buka"
    // (tak ikut kena filter pencarian teks, sama seperti 4 grafik lain yg
    // datang dari backend). Batas "mendekati pensiun" = 5 th sebelum usia
    // pensiun yg berlaku tahun ini, supaya ikut geser bila ambang naik.
    const batasMendekatiPensiun = usiaPensiunTahunIni - 5;
    const statistikUsiaKerja = [
        {
            name: "Fresh Graduate (≤25 th)",
            total: baseRows.filter((r) => r._umur !== null && r._umur <= 25).length,
        },
        {
            name: `Usia Produktif (26-${batasMendekatiPensiun - 1} th)`,
            total: baseRows.filter((r) => r._umur !== null && r._umur > 25 && r._umur < batasMendekatiPensiun).length,
        },
        {
            name: `Mendekati/Masuk Pensiun (≥${batasMendekatiPensiun} th)`,
            total: baseRows.filter((r) => r._umur !== null && r._umur >= batasMendekatiPensiun).length,
        },
    ];
    const filtered = baseRows.filter((r) => {
        const kw = searchQuery.trim().toLowerCase();
        if (!kw) return true;
        return [r.Nik, r.NamaKaryawan, r.NamaJabatan, r.NamaBagian, r.NamaBisnisUnit, r.NamaTipeKaryawan]
            .some((v) => v && v.toString().toLowerCase().includes(kw));
    });
    const totalPage = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const safePage = Math.min(pageC, totalPage);
    const pageRows = filtered.slice((safePage - 1) * PAGE_SIZE, (safePage - 1) * PAGE_SIZE + PAGE_SIZE);

    useEffect(() => {
        setPageC(1);
    }, [searchQuery, data]);

    // ── Export (mengikuti hasil search yang tampil) — label dipetakan manual
    // (bukan mengambil dari DOM) supaya Excel/PDF berisi teks, bukan kode mentah.
    const exportHeader = header.map((h) => h.name);
    const exportBody = () =>
        filtered.map((r) =>
            header.map((h) => {
                const v = r[h.key];
                switch (h.modifiers) {
                    case "Date": return fmtDate(v);
                    case "JenisKelamin": return jenisKelaminLabel(v);
                    case "Pendidikan": return pendidikanLabel(v);
                    case "StatusPerkawinan": return statusPerkawinanLabel(v);
                    case "StatusPajak": return statusPajakLabel(v);
                    case "WargaNegara": return wargaNegaraLabel(v);
                    case "Agama": return agamaLabel(v);
                    case "SistemGaji": return sistemGajiLabel(v);
                    default: return v ?? "";
                }
            })
        );
    const handleExportExcel = () => {
        if (!filtered.length) return;
        downloadExcel({
            fileName: "Report_Karyawan",
            sheet: "data",
            tablePayload: {header: exportHeader, body: exportBody()},
        });
    };
    const handleExportPDF = () => {
        if (!filtered.length) return;
        const doc = new jsPDF({orientation: "landscape"});
        doc.setFontSize(12);
        doc.text("Report Karyawan", 14, 14);
        autoTable(doc, {
            head: [exportHeader],
            body: exportBody(),
            startY: 20,
            styles: {fontSize: 6, cellPadding: 1.5},
            headStyles: {fillColor: [47, 85, 151], textColor: 255, fontStyle: "bold"},
        });
        doc.save("Report_Karyawan.pdf");
    };

    const filterApi = () => {
        setFetching(true);
        dispatch(
            getKaryawanReport({
                "tahun": values.bulan.getFullYear().toString(),
                "bulan": (values.bulan.getMonth() + 1).toString(),
                "BisnisUnitID": values.bisnisUnitId
            })
        ).finally(() => setFetching(false));
        setData([])
    }


    return (
        <>
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <Card>
                                <div className="flex flex-row flex-wrap items-start justify-start w-1/2 px-2 py-2">
                                    <div className={"w-1/3 "}>
                                        <HrdInputGenerator
                                            type={"BisnisUnit"}
                                            name={"bisnisUnitId"}
                                            title={"Bisnis Unit"}
                                            includeAll={true}
                                            value={values}
                                            required={true}
                                            onChange={customHandler}
                                            touched={touched}
                                            errors={errors}
                                            size={"full"}
                                        />
                                    </div>

                                    <div className={"w-1/3"}>
                                        <label
                                            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Buka data
                                        </label>

                                        <button type="button"
                                                onClick={filterApi}
                                                className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 ">
                                            Buka
                                        </button>
                                    </div>

                                </div>

                                {fetching ? (
                                    <div className="w-full pt-0">
                                        <Skeltons/>
                                    </div>
                                ) : (
                                    <div className="flex flex-col items-center content-center ">
                                        <div className="w-full flex flex-row items-center mb-12">
                                            <div
                                                className="w-1/2  my-2 cursor-pointer" ref={elementRef}>
                                                <BarGraphOutside name={"Jenjang Bedasarkan Jenjang"}
                                                                 Statistic={statisticJenjang}
                                                                 width={width} height={height}/>
                                            </div>
                                            <div
                                                className="w-1/2  my-2 cursor-pointer" ref={elementRef}>
                                                <BarGraphOutside name={"Jumlah Bedasarkan Golongan"}
                                                                 Statistic={statisticGolongan}
                                                                 width={width} height={height}/>
                                            </div>
                                        </div>

                                        <div className="w-full flex flex-row items-center mb-12  ">
                                            <div
                                                className="w-1/2  my-2 cursor-pointer" ref={elementRef}>
                                                <BarGraphOutside name={"Jumlah Bedasarkan Agama"}
                                                                 Statistic={statisticAgama}
                                                                 width={width} height={height}/>
                                            </div>
                                            <div
                                                className="w-1/2  my-2 cursor-pointer" ref={elementRef}>
                                                <PieGraphOutside name={"Jumlah Bedasarkan Jenis Kelamin"}
                                                                 Statistic={statisticJK}
                                                                 width={width} height={height}/>
                                            </div>

                                        </div>

                                        <div className="w-full flex flex-row items-center mb-12  ">
                                            <div
                                                className="w-1/2  my-2 cursor-pointer" ref={elementRef}>
                                                <BarGraphOutside name={"Kategori Usia Kerja (Fresh Graduate / Produktif / Mendekati Pensiun)"}
                                                                 Statistic={statistikUsiaKerja}
                                                                 width={width} height={height}/>
                                            </div>
                                        </div>

                                        {/* ── Penanda MERAH: karyawan yg genap usia pensiunnya JATUH
                                            DI TAHUN INI (baik yg tanggalnya sudah lewat maupun yg
                                            masih akan datang tahun ini) — paling mendesak utk HR ── */}
                                        {filtered.filter((r) => r._pensiunTahunIni).length > 0 && (
                                            <div
                                                className="w-full px-4 mt-2 py-3 rounded bg-red-50 border border-red-400 text-red-700 text-sm">
                                                <p className="font-semibold mb-1">
                                                    🔴 {filtered.filter((r) => r._pensiunTahunIni).length} karyawan akan/sudah
                                                    memasuki masa pensiun di tahun {tahunIni} ini:
                                                </p>
                                                <ul className="list-disc list-inside">
                                                    {filtered.filter((r) => r._pensiunTahunIni).map((r) => (
                                                        <li key={r.Nik}>
                                                            {r.NamaKaryawan} ({r.Nik}) — pensiun {r.TanggalPensiun}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}

                                        {/* ── Penanda kuning: sudah lewat usia pensiun di tahun
                                            SEBELUMNYA (bukan tahun ini) — masih relevan tapi tak
                                            semendesak yg tahun ini ── */}
                                        {filtered.filter((r) => r._sudahPensiun && !r._pensiunTahunIni).length > 0 && (
                                            <div
                                                className="w-full px-4 mt-2 py-2 rounded bg-amber-50 border border-amber-300 text-amber-800 text-sm">
                                                ⚠ {filtered.filter((r) => r._sudahPensiun && !r._pensiunTahunIni).length} karyawan
                                                sudah melewati usia pensiun pada tahun-tahun sebelumnya — lihat kolom
                                                "Status Pensiun".
                                            </div>
                                        )}

                                        {/* ── Toolbar: Export kiri, Cari kanan ── */}
                                        <div
                                            className="flex w-full justify-between px-4 pt-2 flex-col sm:flex-row mt-2 gap-2">
                                            <div className="flex flex-row gap-2 flex-wrap">
                                                <button onClick={handleExportExcel}
                                                        className="flex items-center justify-center gap-2 h-[42px] px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-green-600 hover:bg-green-600 hover:text-white">
                                                    Export Excel
                                                </button>
                                                <button onClick={handleExportPDF}
                                                        className="flex items-center justify-center gap-2 h-[42px] px-4 rounded shadow text-sm font-semibold border bg-white text-gray-800 border-red-400 hover:bg-red-400 hover:text-white">
                                                    Export PDF
                                                </button>
                                            </div>
                                            <div className="flex flex-row w-full sm:w-96">
                                                <input type="text" value={searchQuery}
                                                       onChange={(e) => setSearchQuery(e.target.value)}
                                                       placeholder="Cari Nik / Nama / Jabatan / Bagian"
                                                       className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full h-[42px]"/>
                                            </div>
                                        </div>

                                        <DynamicTable withoutAttribut={true} data={pageRows} header={header}/>

                                        {/* ── Info + Pagination ── */}
                                        <div
                                            className="flex flex-row justify-between items-center gap-4 w-full px-4 py-4 text-sm text-gray-600">
                                            <span>{filtered.length} data</span>
                                            <div className="flex items-center gap-4">
                                                <button onClick={() => setPageC((p) => Math.max(1, p - 1))}
                                                        disabled={safePage <= 1}
                                                        className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Prev
                                                </button>
                                                <span>Page {safePage} / {totalPage}</span>
                                                <button
                                                    onClick={() => setPageC((p) => Math.min(totalPage, p + 1))}
                                                    disabled={safePage >= totalPage}
                                                    className="border px-4 py-1 rounded disabled:opacity-50 hover:bg-gray-100">Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </Card>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default KaryawanReport;
